"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserRequests = void 0;
const Requests_1 = require("../../Requests");
class UserRequests extends Requests_1.Requests {
    constructor() {
        super(...arguments);
        this.resource = "users";
    }
}
exports.UserRequests = UserRequests;
//# sourceMappingURL=UserRequests.js.map